import { compactNumber } from '../../format'

import style from './style.module.css'

/** The same five metrics the desktop rail's Statistics section shows. */
const STAT_TILES = [
  { key: 'companies', label: 'companies' },
  { key: 'hiringCompanies', label: 'hiring now' },
  { key: 'openRoles', label: 'open roles' },
  { key: 'upcomingEvents', label: 'upcoming events' },
  { key: 'savedCount', label: 'saved' },
]

const Statistic = ({ stats }) => {
  if (!stats) {
    return (
      <div className={style.statistic} aria-hidden="true">
        {STAT_TILES.map((tile) => (
          <div
            className={`${style.statistic_item} ${style.statistic_item_ghost}`}
            key={tile.key}
          />
        ))}
      </div>
    )
  }

  return (
    <ul className={style.statistic} aria-label="Spotlight statistics">
      {STAT_TILES.map((tile) => (
        <li className={style.statistic_item} key={tile.key}>
          <span className={style.statistic_number}>{compactNumber(stats[tile.key])}</span>
          <span className={style.statistic_text}>{tile.label}</span>
        </li>
      ))}
    </ul>
  )
}

export default Statistic
